/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Processed/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Processed({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/Actions/Content/SyncAction/Content/LastSyncStatus/Content/Processed"
  
}) {
  return null
}